import { Col, Row } from 'antd';
import React, { FC, memo, MouseEventHandler, useCallback } from 'react';
import { TaskId } from 'api/models';
import { TaskStatusPicker } from 'components/atoms/tasks/task-status-picker';
import { TaskMoreActions } from 'components/molecules/tasks/more-actions';
import { Task } from 'data/tasks';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';
import {
  AtRiskIcon,
  CompletedCard,
  ContentWrapper,
  MoreActionsCol,
  StatusWrapper,
} from './task-card.styles';
import { CompletedTaskCardTitle } from './title';

interface CompletedCard {
  task: Task;
  openTask: MouseEventHandler<HTMLDivElement>;
}

const Card: FC<CompletedCard> = memo(({ task, openTask }) => {
  return (
    <CompletedCard
      bordered={false}
      hoverable
      private={task.private}
      onClick={openTask}
      data-cy={task.taskName}
    >
      <StatusWrapper data-cy="projects.card.status">
        {task.atRisk && <AtRiskIcon />}
        <TaskStatusPicker
          taskId={task.taskId}
          projectId={task.project}
          type={task.type}
          progress={task.progress}
          fields={task.fields}
        />
      </StatusWrapper>

      <ContentWrapper>
        <Row gutter={0} wrap={false}>
          <Col flex="auto">
            <CompletedTaskCardTitle task={task} rows={1} />
          </Col>
          <MoreActionsCol
            flex="32px"
            id="more-actions"
            onClick={(e) => e.stopPropagation()}
          >
            <TaskMoreActions data={task} />
          </MoreActionsCol>
        </Row>
      </ContentWrapper>
    </CompletedCard>
  );
});

export const ComplatedTaskCard: FC<{
  task: Task;
}> = ({ task }) => {
  const navigateToTask = useNavigateToTask();

  const openTask: MouseEventHandler<HTMLDivElement> = useCallback(() => {
    navigateToTask(TaskId(task.project, task.taskId));
  }, [navigateToTask, task.project, task.taskId]);

  return <Card openTask={openTask} task={task} />;
};
